import React, { useEffect, useState } from "react";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import NavPills from "components/NavPills/NavPills.js";

import ValueBoniGroup from "./ValueBoniGroup";
import { wsFindBy, wsCreate, wsRemove } from "services/WService.js";

import GroupListBonification from "./GroupListBonification/GroupListBonification";
import ListGroupBonification from "./ListGroupBonification";

export default function BonificationGroup(props) {
  const { rule, showNotify } = props;

  //#region  estado para listados de filtros --
  const [warehouses, setWarehouses] = useState([]);
  const [providers, setProviders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [families, setFamilies] = useState([]);

  async function listProviders() {
    let response = await wsFindBy("base/business-partner", { CardType: 'S', QryGroup1: 'Y' });
    setProviders(response.data);
  }

  async function listCategories(provider_id) {
    let response = await wsFindBy(
      "logi/category",
      "base_business_partner_id",
      provider_id
    );
    setCategories(response.data);
  }

  async function listFamilies(category_id) {
    let response = await wsFindBy(
      "logi/family",
      "logi_category_id",
      category_id
    );
    setFamilies(response.data);
  }
  //#endregion

  const [boniGroups, setBoniGroups] = useState([]);

  const promo = props.promotion;
  const statePromo = promo.state == "N" || promo.state == "G" ? false : true;

  const [currentBoniGroup, setCurentBoniGroup] = useState({ index: 0, id: 0 });

  async function listBoniGroups() {
    const [groupResponse, productResponse] = await Promise.all([
      wsFindBy("prom/bonification-group", "prom_rule_id", rule.id),
      wsFindBy("prom/bonification-product", "prom_rule_id", rule.id)
    ]);

    if (groupResponse.success && productResponse.success) {
      if (groupResponse.data.length > 0) {
        setCurentBoniGroup(0);
      }
      setBoniGroups(
        groupResponse.data.map((item) => {
          item.products = productResponse.data.filter(
            (product) => product.prom_bonification_group_id == item.id
          );
          return item;
        })
      );

      if (groupResponse.data.length > 0) {
        setCurentBoniGroup({ index: 0, id: groupResponse.data[0].id });
        props.setCurrentBoniGroup(true);
      } else {
        setCurentBoniGroup({ index: 0, id: 0 });
      }
    }
  }

  //Funcion para eliminar aqui --
  async function deleteBoniProduct(product) {
    let response = await wsRemove("prom/bonification-product", product.id);
    if (response.success) {
      listBoniProducts(product.prom_bonification_group_id);
      showNotify(response.message);
    } else {
      showNotify(response.message, "error");
    }
  }

  //Listar productos de bonificación
  async function listBoniProducts(boniGroupId = undefined) {
    let response = await wsFindBy(
      "prom/bonification-product",
      "prom_bonification_group_id",
      boniGroupId
    );

    if (response.success) {
      let newBoniGroups = boniGroups.map((group) => {
        if (group.id == boniGroupId) {
          group.products = response.data;
        }
        return group;
      });
      setBoniGroups(newBoniGroups);
    }
  }

  async function addBoniGroup() {
    if (!!rule) {
      let response = await wsCreate("prom/bonification-group", {
        prom_promotion_id: rule.prom_promotion_id,
        prom_rule_id: rule.id,
        condition: "Q",
        quantity: "1",
        ume: "1",
        discount: "1",
        allow_credit_note: "1"
      });

      if (response.success) {
        showNotify(response.message);
        response.data.products = [];
        setBoniGroups([...boniGroups, response.data]);
        setCurentBoniGroup({ index: 0, id: response.data.id });
        props.setCurrentBoniGroup(true);
      } else {
        showNotify(response.message, "error");
      }
    } else {
      showNotify("Primero seleccione una regla", "info");
    }
  }

  function verifyItemExists(item) {
    for (let boniGroup of boniGroups) {
      let product = boniGroup.products.find((itemInGroup) => {
        return itemInGroup.ItemCode == item.ItemCode;
      });
      if (product !== undefined) {
        return true;
      }
    }
    return false;
  }

  async function addProduct(product) {
    if (verifyItemExists(product)) {
      showNotify("Producto ya esta agregado", "info");
      return;
    }

    if (currentBoniGroup.id == 0) {
      showNotify("Cree un grupo de bonificación", "info");
      return;
    }

    let response = await wsCreate("prom/bonification-product", {
      prom_bonification_group_id: currentBoniGroup.id,
      logi_product_id: product.id,
      price: "12",
      priority: "0"
    });
    if(response.success){
      listBoniProducts(currentBoniGroup.id);
    } else {
      showNotify(response.message, "error");
    }
  }

  useEffect(() => {
    listProviders();
    listCategories(promo.base_business_partner_id);
  }, [promo]);

  useEffect(() => {
    if (!!rule) {
      listBoniGroups();
    }
  }, [rule]);

  return (
    <div>
      {statePromo == false ? (
        <GridItem xs={12}>
          <GroupListBonification
            promo={promo}
            providers={providers}
            categories={categories}
            listCategories={listCategories}
            listFamilies={listFamilies}
            setCategories={setCategories}
            setFamilies={setFamilies}
            families={families}
            addProduct={addProduct}
            warehouses={warehouses}
            setWarehouses={setWarehouses}
          />
        </GridItem>
      ) : undefined}
      <GridItem xs={12}>
        <hr />
        <h4
          style={{
            textAlign: "center",
            fontWeight: "bold",
            textDecoration: "underline"
          }}
        >
          Grupos de bonificación de la regla # {!!rule ? rule.id : "..."}
        </h4>
        <Button disabled={statePromo} onClick={addBoniGroup}>
          Nuevo grupo de bonificación
        </Button>
        <NavPills
          color="primary"
          active={currentBoniGroup.index}
          setActive={(index) => {
            setCurentBoniGroup({ index, id: boniGroups[index].id });
          }}
          horizontal={{
            tabsGrid: { xs: 12, lg: 4 },
            contentGrid: { xs: 12, lg: 8 }
          }}
          tabs={boniGroups.map((boniGroup, i) => {
            return {
              tabButton: `Grupo ${i + 1}`,
              tabContent: (
                <div>
                  <GridItem xs={12}>
                    <ValueBoniGroup
                      rule={rule}
                      grupo={i + 1}
                      boniGroup={boniGroup}
                      reload={listBoniGroups}
                      promo={promo}
                      showNotify={showNotify}
                      reloadPromoGeneral={props.reloadPromo}
                      confirmDeleteGroup={props.confirmDeleteGroup}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <ListGroupBonification
                      boniGroup={boniGroup}
                      setBoniGroups={setBoniGroups}
                      deleteBoniProduct={deleteBoniProduct}
                      statePromo={statePromo}
                      promotion={promo}
                      showNotify={showNotify}
                    />
                  </GridItem>
                </div>
              ),
            };
          })}
        />
      </GridItem>
    </div>
  );
}
